import { w } from '@tinkoff/statist-page-data';
import { IosBridge } from './ios-bridge';
import { AndroidBridge } from './android-bridge';
import { SUPPORTED_MAJOR_VERSION } from './constants';
var WebviewBridge = /** @class */ (function () {
    function WebviewBridge() {
        this.bridges = [];
        this.connectedBridge = null;
        var bridgesMap = w._statistWebviewBridges || (w._statistWebviewBridges = {});
        var existedBridge = bridgesMap[SUPPORTED_MAJOR_VERSION];
        // если уже есть объект с нужной версией, то используем его поля
        if (existedBridge) {
            this.bridges = existedBridge.bridges;
            this.connectedBridge = existedBridge.connectedBridge;
            return;
        }
        this.bridges = [new AndroidBridge(), new IosBridge()];
        // устанавливаем значения в глобальную переменную, чтобы не создавать новые объекты
        bridgesMap[SUPPORTED_MAJOR_VERSION] = this;
    }
    WebviewBridge.prototype.getConnectedBridge = function () {
        var _a;
        if (this.connectedBridge === null) {
            this.connectedBridge = (_a = this.bridges.find(function (b) { return b.isConnected(); })) !== null && _a !== void 0 ? _a : null;
        }
        return this.connectedBridge;
    };
    WebviewBridge.prototype.setup = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.getConnectedBridge()) === null || _a === void 0 ? void 0 : _a.setup) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : Promise.resolve();
    };
    WebviewBridge.prototype.getSharedParameters = function () {
        var _a, _b;
        return (_b = (_a = this.getConnectedBridge()) === null || _a === void 0 ? void 0 : _a.getSharedParameters()) !== null && _b !== void 0 ? _b : null;
    };
    WebviewBridge.prototype.getApiKey = function () {
        var _a, _b;
        return (_b = (_a = this.getConnectedBridge()) === null || _a === void 0 ? void 0 : _a.getApiKey()) !== null && _b !== void 0 ? _b : null;
    };
    WebviewBridge.prototype.notifyEventHappened = function () {
        var _a;
        (_a = this.getConnectedBridge()) === null || _a === void 0 ? void 0 : _a.notifyEventHappened();
    };
    return WebviewBridge;
}());
export { WebviewBridge };
//# sourceMappingURL=webview-bridge.js.map